import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

export default function Register() {

  const [name,setName]=useState('');
  const [email,setEmail]=useState('');
  const [password,setPassword]=useState('');
  const [role,setRole]=useState('customer');
  const [loading,setLoading]=useState(false);

  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await api.post('/register',{ name, email, password, role });
      alert('Registered. Please login.');
      nav('/login');
    } catch (err) {
      alert('Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">

      {/* 🔥 CENTER WRAPPER */}
      <div className="mx-auto" style={{ maxWidth: "420px" }}>

        <div className="card shadow-sm p-3">

          <h4 className="text-center mb-3">📝 Register</h4>

          <form onSubmit={submit}>

            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                className="form-control"
                value={name}
                onChange={e=>setName(e.target.value)}
                placeholder="Enter name"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                className="form-control"
                value={email}
                onChange={e=>setEmail(e.target.value)}
                type="email"
                placeholder="Enter email"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                className="form-control"
                value={password}
                onChange={e=>setPassword(e.target.value)}
                type="password"
                placeholder="Enter password"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Role</label>
              <select
                className="form-control"
                value={role}
                onChange={e=>setRole(e.target.value)}
              >
                <option value="customer">Customer</option>
                <option value="employee">Employee</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            {/* DESKTOP BUTTON */}
            <button
              className="btn btn-primary w-100 d-none d-md-block"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register"}
            </button>

          </form>

        </div>

      </div>

      {/* 🔥 MOBILE STICKY BUTTON */}
      <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
        <button
          className="btn btn-primary w-100"
          onClick={submit}
          disabled={loading}
        >
          {loading ? "Registering..." : "Register"}
        </button>
      </div>

      {/* spacing for mobile */}
      <div className="d-md-none" style={{ height: "70px" }}></div>

    </div>
  );
}